const organisation = {
  email_title_required: 'The email title is required when the message is filled',
  email_message_required: 'The email message is required when the title is filled',
};

export default organisation;
